module.exports = __webpack_public_path__ + "img/1.95709cbc.png";